import { wrapTo, setFilter, layerConfigChange } from 'kepler.gl/actions';
import { routeCoverageAnimation, selectFilterLatLongAnimation, segmentScoreAnimation, segmentHeatmapScoreAnimation } from '../animations/Animation';

export const handleTrafficDropDown = (selected, store, setShowDropDownLoader) => {
    console.log("handleTrafficDropDown Applied:", selected);
    if (selected.length > 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs")], 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(0, "value", selected, undefined)));
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymjs")], 
            {
                isVisible: false
            }
        )));
    }

    setShowDropDownLoader(true);
    setTimeout(() => {
        setShowDropDownLoader(false); // Hide loader after 4 seconds
    }, 2000);
};

export const handleMunicipalDropDown = (selected, store, setShowDropDownLoader) => {
    console.log("handleMunicipalDropDown Applied:", selected);

    if (selected.length > 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds")], 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(1, "value", selected, undefined)));
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "h5kymds")], 
            {
                isVisible: false
            }
        )));
    }

    setShowDropDownLoader(true);
    setTimeout(() => {
        setShowDropDownLoader(false); // Hide loader after 4 seconds
    }, 2000);
};

export const handleRoadSignDropDown = (selected, store) => {
    console.log("handleRoadSignDropDown Applied:", selected);

    if (selected.length > 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "i5kyees")], 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(2, "value", selected, undefined)));
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "i5kyees")], 
            {
                isVisible: false
            }
        )));
    }
};

export const handleJurisdictionDropDown = (selected, store, setPreviousWardDropDownSelected, setPreviousZoneDropDownSelected, setPreviousMPDropDownSelected, setPreviousACDropDownSelected, setPreviousPoliceDropDownSelected, setPreviousTrafficPoliceDropDownSelected) => {

    if (selected['BBMP Ward'].length > 0) {
        const wardLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q1");
        const wardLayer = store.getState().keplerGl.evidence.visState.layers[wardLayerIndex];
        store.dispatch(wrapTo('evidence', layerConfigChange(
            wardLayer, 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(3, "value", selected['BBMP Ward'].map(s => s.replace(/\s?\([\d\w\s]*\)$/, "")), undefined)));
        setPreviousWardDropDownSelected(selected['BBMP Ward']);

        const selectedWardLayerData = store.getState().keplerGl.evidence.visState.layerData[wardLayerIndex];
        if (selectedWardLayerData.data.length > 10) {
            selectFilterLatLongAnimation(store, 12.976124480741094, 77.60488025956508, 11.4);
        } else {
            const centerPoint = getCenterPoint(selectedWardLayerData.data[0].bbox);
            selectFilterLatLongAnimation(store, centerPoint.latitude, centerPoint.longitude);
        }
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q1")], 
            {
                isVisible: false
            }
        )));
        setPreviousWardDropDownSelected([]);
    }

    if (selected['BBMP Zone'].length > 0) {
        const zoneLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q2");
        const zoneLayer = store.getState().keplerGl.evidence.visState.layers[zoneLayerIndex];
        store.dispatch(wrapTo('evidence', layerConfigChange(
            zoneLayer, 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(4, "value", selected['BBMP Zone'].map(s => s.replace(/\s?\([\d\w\s]*\)$/, "")), undefined)));
        setPreviousZoneDropDownSelected(selected['BBMP Zone']);

        const selectedZoneLayerData = store.getState().keplerGl.evidence.visState.layerData[zoneLayerIndex];
        console.log("selectedZoneLayerData", selectedZoneLayerData);
        if (selectedZoneLayerData.data.length > 10) {
            selectFilterLatLongAnimation(store, 12.976124480741094, 77.60488025956508, 11.4);
        } else {
            const firstPoint = selectedZoneLayerData.data[0].geometry.coordinates[0][0];
            selectFilterLatLongAnimation(store, firstPoint[1], firstPoint[0], 13);
        }
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q2")], 
            {
                isVisible: false
            }
        )));
        setPreviousZoneDropDownSelected([]);
    }

    if (selected['Parliamentary Constituency'].length > 0) {
        const pcLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q3");
        const pcLayer = store.getState().keplerGl.evidence.visState.layers[pcLayerIndex];
        store.dispatch(wrapTo('evidence', layerConfigChange(
            pcLayer, 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(5, "value", selected['Parliamentary Constituency'].map(s => s.replace(/\s?\([\d\w\s]*\)$/, "")), undefined)));
        setPreviousMPDropDownSelected(selected['Parliamentary Constituency']);

        const selectedPCLayer = store.getState().keplerGl.evidence.visState.layerData[pcLayerIndex];
        if (selectedPCLayer.data.length > 10) {
            selectFilterLatLongAnimation(store, 12.976124480741094, 77.60488025956508, 11.4);
        } else {
            const firstPoint = selectedPCLayer.data[0].geometry.coordinates[0][0];
            selectFilterLatLongAnimation(store, firstPoint[1], firstPoint[0], 13);
        }
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q3")], 
            {
                isVisible: false
            }
        )));
        setPreviousMPDropDownSelected([]);
    }

    if (selected['Assembly Constituency'].length > 0) {
        const acLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q4");
        const acLayer = store.getState().keplerGl.evidence.visState.layers[acLayerIndex];
        store.dispatch(wrapTo('evidence', layerConfigChange(
            acLayer, 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(6, "value", selected['Assembly Constituency'].map(s => s.replace(/\s?\([\d\w\s]*\)$/, "")), undefined)));
        setPreviousACDropDownSelected(selected['Assembly Constituency']);

        const selectedACLayerData = store.getState().keplerGl.evidence.visState.layerData[acLayerIndex];
        if (selectedACLayerData.data.length > 10) {
            selectFilterLatLongAnimation(store, 12.976124480741094, 77.60488025956508, 11.4);
        } else {
            const firstPoint = selectedACLayerData.data[0].geometry.coordinates[0][0];
            selectFilterLatLongAnimation(store, firstPoint[1], firstPoint[0], 13);
        }
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q4")], 
            {
                isVisible: false
            }
        )));
        setPreviousACDropDownSelected([]);
    }

    if (selected['BLR Police'].length > 0) {
        const policeLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q5");
        const policeLayer = store.getState().keplerGl.evidence.visState.layers[policeLayerIndex];
        store.dispatch(wrapTo('evidence', layerConfigChange(
            policeLayer, 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(7, "value", selected['BLR Police'].map(s => s.replace(/\s?\([^)]+\)$/, "")), undefined)));
        setPreviousPoliceDropDownSelected(selected['BLR Police']);

        const selectedPoliceLayerData = store.getState().keplerGl.evidence.visState.layerData[policeLayerIndex];
        if (selectedPoliceLayerData.data.length > 10) {
            selectFilterLatLongAnimation(store, 12.976124480741094, 77.60488025956508, 11.4);
        } else {
            const firstPoint = selectedPoliceLayerData.data[0].geometry.coordinates[0][0];
            selectFilterLatLongAnimation(store, firstPoint[1], firstPoint[0], 14);
        }
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q5")], 
            {
                isVisible: false
            }
        )));
        setPreviousPoliceDropDownSelected([]);
    }

    if (selected['BLR Traffic Police'].length > 0) {
        const trafficPoliceLayerIndex = store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q6");
        const trafficPoliceLayer = store.getState().keplerGl.evidence.visState.layers[trafficPoliceLayerIndex];
        store.dispatch(wrapTo('evidence', layerConfigChange(
            trafficPoliceLayer, 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(8, "value", selected['BLR Traffic Police'].map(s => s.replace(/\s?\([^)]+\)$/, "")), undefined)));
        setPreviousTrafficPoliceDropDownSelected(selected['BLR Traffic Police']);

        const selectedTrafficPoliceLayerData = store.getState().keplerGl.evidence.visState.layerData[trafficPoliceLayerIndex];
        if (selectedTrafficPoliceLayerData.data.length > 10) {
            selectFilterLatLongAnimation(store, 12.976124480741094, 77.60488025956508, 11.4);
        } else {
            const firstPoint = selectedTrafficPoliceLayerData.data[0].geometry.coordinates[0][0];
            selectFilterLatLongAnimation(store, firstPoint[1], firstPoint[0], 14);
        }
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q6")], 
            {
                isVisible: false
            }
        )));
        setPreviousTrafficPoliceDropDownSelected([]);
    }
};

export const handleInitialLoadJurisdictionDropDown = (selected, store, setPreviousWardDropDownSelected, previousWardDropDownSelected, setPreviousZoneDropDownSelected, previousZoneDropDownSelected, setPreviousMPDropDownSelected, previousMPDropDownSelected, setPreviousACDropDownSelected, previousACDropDownSelected, setPreviousPoliceDropDownSelected, previousPoliceDropDownSelected, setPreviousTrafficPoliceDropDownSelected, previousTrafficPoliceDropDownSelected) => {
    console.log("handleJurisdictionDropDown zone Initial Load Applied:", selected);
    console.log("handleJurisdictionDropDown zone previousWardDropDownSelected Applied:", previousWardDropDownSelected);

    if (selected['BBMP Ward'].length === 0 && previousWardDropDownSelected.length === 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q1")], 
            {
                isVisible: false
            }
        )));
        setPreviousWardDropDownSelected([]);
    } else if (previousWardDropDownSelected.length > 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q1")], 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(3, "value", selected['BBMP Ward'].map(s => s.replace(/\s?\([\d\w\s]*\)$/, "")), undefined)));
        setPreviousWardDropDownSelected(selected['BBMP Ward']);
    }

    if (selected['BBMP Zone'].length === 0 && previousZoneDropDownSelected.length === 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q2")], 
            {
                isVisible: false
            }
        )));
        setPreviousZoneDropDownSelected([]);
    } else if (previousZoneDropDownSelected.length > 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q2")], 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(4, "value", selected['BBMP Zone'].map(s => s.replace(/\s?\([\d\w\s]*\)$/, "")), undefined)));
        setPreviousZoneDropDownSelected(selected['BBMP Zone']);
    }

    if (selected['Parliamentary Constituency'].length === 0 && previousMPDropDownSelected.length === 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q3")], 
            {
                isVisible: false
            }
        )));
        setPreviousMPDropDownSelected([]);
    } else if (previousMPDropDownSelected.length > 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q3")], 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(5, "value", selected['Parliamentary Constituency'].map(s => s.replace(/\s?\([\d\w\s]*\)$/, "")), undefined)));
        setPreviousMPDropDownSelected(selected['Parliamentary Constituency']);
    }

    if (selected['Assembly Constituency'].length === 0 && previousACDropDownSelected.length === 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q4")], 
            {
                isVisible: false
            }
        )));
        setPreviousACDropDownSelected([]);
    } else if (previousACDropDownSelected.length > 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q4")], 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(6, "value", selected['Assembly Constituency'].map(s => s.replace(/\s?\([\d\w\s]*\)$/, "")), undefined)));
        setPreviousACDropDownSelected(selected['Assembly Constituency']);
    }

    if (selected['BLR Police'].length === 0 && previousPoliceDropDownSelected.length === 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q5")], 
            {
                isVisible: false
            }
        )));
        setPreviousPoliceDropDownSelected([]);
    } else if (previousPoliceDropDownSelected.length > 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q5")], 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(7, "value", selected['BLR Police'].map(s => s.replace(/\s?\([^)]+\)$/, "")), undefined)));
        setPreviousPoliceDropDownSelected(selected['BLR Police']);
    }

    if (selected['BLR Traffic Police'].length === 0 && previousTrafficPoliceDropDownSelected.length === 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q6")], 
            {
                isVisible: false
            }
        )));
        setPreviousTrafficPoliceDropDownSelected([]);
    } else if (previousTrafficPoliceDropDownSelected.length > 0) {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "qoo6q6")], 
            {
                isVisible: true
            }
        )));
        store.dispatch(wrapTo('evidence', setFilter(7, "value", selected['BLR Traffic Police'].map(s => s.replace(/\s?\([^)]+\)$/, "")), undefined)));
        setPreviousTrafficPoliceDropDownSelected(selected['BLR Traffic Police']);
    }
};

export const handleToggleRouteCoverage = (state, store) => {
    console.log("handleToggleRouteCoverage Clicked:", state);
    if (state) {

        // store.getState().keplerGl.evidence.visState.layers.map((layer, index) => {
        //     if (layer.config.dataId != 'routecoverage') {
        //         store.dispatch(wrapTo('evidence', layerConfigChange(
        //             store.getState().keplerGl.evidence.visState.layers[index], 
        //             {
        //                 isVisible: false
        //             }
        //         )));
        //     }
        // });

        routeCoverageAnimation(store)

        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "routecoverage")], 
            {
                isVisible: true
            }
        )));
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "routecoverage")], 
            {
                isVisible: false
            }
        )));
    }
};

export const handleToggleSegmentScore = (state, store) => {
    console.log("handleToggleSegmentScore Clicked:", state);
    if (state) {
        // store.getState().keplerGl.evidence.visState.layers.map((layer, index) => {
        //     if (layer.config.dataId != 'segmentscore') {
        //         store.dispatch(wrapTo('evidence', layerConfigChange(
        //             store.getState().keplerGl.evidence.visState.layers[index], 
        //             {
        //                 isVisible: false
        //             }
        //         )));
        //     }
        // });

        segmentScoreAnimation(store)

        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "segmentscore")], 
            {
                isVisible: true
            }
        )));
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "segmentscore")], 
            {
                isVisible: false
            }
        )));
    }
}

export const handleToggleSegmentHeatmapScore = (state, store) => {
    console.log("handleToggleSegmentHeatmapScore Clicked:", state);
    if (state) {
        // store.getState().keplerGl.evidence.visState.layers.map((layer, index) => {
        //     if (layer.config.dataId != 'segmentheatmapscore') {
        //         store.dispatch(wrapTo('evidence', layerConfigChange(
        //             store.getState().keplerGl.evidence.visState.layers[index], 
        //             {
        //                 isVisible: false
        //             }
        //         )));
        //     }
        // });

        segmentHeatmapScoreAnimation(store)

        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "segmentheatmapscore")], 
            {
                isVisible: true
            }
        )));
    } else {
        store.dispatch(wrapTo('evidence', layerConfigChange(
            store.getState().keplerGl.evidence.visState.layers[store.getState().keplerGl.evidence.visState.layers.findIndex(layer => layer['id'] === "segmentheatmapscore")], 
            {
                isVisible: false
            }
        )));
    }
}

const getCenterPoint = (bbox) => {
    const minLng = bbox[0];
    const minLat = bbox[1];
    const maxLng = bbox[2];
    const maxLat = bbox[3];

    const centerLat = (minLat + maxLat) / 2;
    const centerLng = (minLng + maxLng) / 2;

    return { latitude: centerLat, longitude: centerLng };
};